module.exports = __webpack_public_path__ + "static/media/DMR.cda3acb2.png";